import { Injectable } from '@angular/core';
import { Router, NavigationEnd, RoutesRecognized, ActivatedRoute } from '@angular/router';

@Injectable({providedIn: 'root'})
export class PreviousRouteService {

  private previousUrl: string;
  private currentUrl: string;
  private targetUrl: any;
  private previousUrlState: any;
  private currentUrlState: any;
  private routerStorage: Array<any> = [];

  parentRoutingURL: any = [
    '/admin',
    '/dashboard',
    '/inventory',
    '/physicalInventory',
    '/requisition',
    '/spoilage',
    '/message',
    '/transfer',
    '/purchaseOrder',
    '/about',
    '/reports',
    '/receiving',
    '/alllocations',
    '/requisition/viewrequisition',
    '/inventory/inventorylist',
    '/transfer/transfer',
    '/spoilage/spoilagelist',
    '/purchaseOrder/purchase',
    '/receiving/allreceiving',
    '/purchaserequest/pr-landing',
    '/pendingapproval/allpendingapprovals',
    '/physicalInventory/loadsaved'
  ];
  constructor(
    private router: Router,
    private activatedRouteSnapshot: ActivatedRoute
    ) {
    const _that = this;
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        if (event.url !== '/' ) {
          const routerLocal = (JSON.parse(window.sessionStorage.getItem('strogeLocateRoute')) !== null) ?
          JSON.parse(window.sessionStorage.getItem('strogeLocateRoute')) : [];

          const ParentLocal = (JSON.parse(window.sessionStorage.getItem('strogeParentRoute')) !== null) ?
          JSON.parse(window.sessionStorage.getItem('strogeParentRoute')) : [];
          if (routerLocal) {
            const RouterLength = routerLocal.length;
            if (event.url !== routerLocal[RouterLength - 1 ]) {
              routerLocal.push(event.url);
              if ( _that.parentRoutingURL.findIndex( parentRouter => parentRouter === event.url) > -1) {
                ParentLocal.push(event.url);
              }
            }
          }
          window.sessionStorage.setItem('strogeLocateRoute', JSON.stringify(routerLocal));
          window.sessionStorage.setItem('strogeParentRoute', JSON.stringify(ParentLocal));
        }
        this.previousUrl = this.getPreviousRoutingUrl();
      }
      this.targetUrl = event;
    });
    }
    /**
     * @function getPreviousRoutingUrl()
     * @description Routing the parent url
     * @input None
     * @output None
     */

     getPreviousRoutingUrl() {
      let previousNavigate: string;
      const routerLocal = JSON.parse(window.sessionStorage.getItem('strogeLocateRoute'));
      if (routerLocal.length > 1) {
         const currentIndex = routerLocal.indexOf(this.currentUrl);
         console.log(currentIndex);
         if (currentIndex > -1) {
           const previousRoutIndex = currentIndex - 1;
           previousNavigate = routerLocal[previousRoutIndex];
         }
       }
       return previousNavigate;
     }
    /**
     * @function getParentRoutingUrl();
     * @params None
     * @description get the last navigationg url
     * @output params none
     */
     getParentRoutingUrl() {
      let previousParentRouting: string;
      const parentLocal = JSON.parse(window.sessionStorage.getItem('strogeParentRoute'));
      if (parentLocal.length > 1) {
        previousParentRouting = parentLocal.slice(-1)[0];
       }
       return previousParentRouting;
     }

  public getPreviousUrl() {
    return this.previousUrl;
  }
  public getNextUrl() {
    return this.targetUrl.url;
  }
   /**
   * @function navigationBack();
   * @param None
   * @description Navigate to back page
   */
  navigationBack() {
    const previousUrl = this.getPreviousUrl();
    this.router.navigateByUrl(previousUrl);
  }
}
